export enum PathsEmum {
    '/perfil' = 'Mi perfil',
    '/Cambios-Producto' = 'Cambios de producto',
    '/Impulsa-GEPP' = 'Impulsa GEPP',
    '/Foto-Exito' = 'Autoevaluación',
    '/Games' = 'Juegos',
    '/Califica' = 'Califícanos',
    '/Centro-Asistencia' = 'Centro de Asistencia',
    '/Contacto' = 'Línea de contacto',

    '/main/Autoevaluacion' = 'Autoevaluación',
    '/main/ProgramaCDG' = 'Programa',
    '/main/ProgramaGJ' = 'Programa',
    '/main/ProgramaSG' = 'Programa',
    '/main/Tienda' = 'Tienda',
    '/main/Compras' = 'Historial',
    '/main/Mural' = 'Para Ti',
    '/main/Califica' = 'Califícanos',
    '/main/Centro-Asistencia' = 'Centro de asistencia',
    '/main/CreceMas' = 'Crece Negocio',
    '/main/Mas' = 'Más',
    '/main/ProgramaRecomPepsi' = 'Recompepsi'
}

export const PATHS_IGNORE_BACK: { [key: string]: boolean } = {
    '/Load-Game': true,
    '/splash-screen': true,
    '/home': true
};
